const price_ids = {
  solo_monthly: "price_1PMMIFDlxFxJRvrq0FuFI9pN",
  solo_yearly: "price_1PMbcGDlxFxJRvrqtTDBlFD1",
  agency_monthly: "price_1PMbd5DlxFxJRvrq8IOVQQFQ",
  agency_yearly: "price_1PMbedDlxFxJRvrqiYLjA62Z"
};

export default price_ids;
